export const defaultYoutubeVideos = [
  'https://www.youtube.com/watch?v=kuFCP5tkg1U',
  'https://www.youtube.com/watch?v=3vqS64aLbPw',
  'https://www.youtube.com/watch?v=SyMoQ7YD4VQ',
];
